import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { ApiService } from '../api/api.service';
import {
  GetListDocumentByPatientModel,
  GetListDocumentByWoundModel,
  UploadDocumentModel,
  UploadDocumentRequest,
} from '../../models/document/document.model';
import { BaseApiResponse } from '../../models/api/api.model';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  private readonly baseUrl = `${environment.apiLocations.patient}/document`;

  constructor(private apiService: ApiService) {}

  getDocumentsByPatient(
    patientId: string
  ): Observable<GetListDocumentByPatientModel[]> {
    const url = `${this.baseUrl}/getListDocumentByPatient/${patientId}`;
    return this.apiService
      .get<GetListDocumentByPatientModel[]>(url)
      .pipe(map((res) => res?.data ?? []));
  }

  getDocumentsByWound(
    woundId: string
  ): Observable<GetListDocumentByWoundModel[]> {
    const url = `${this.baseUrl}/getListDocumentByWound/${woundId}`;
    return this.apiService
      .get<GetListDocumentByWoundModel[]>(url)
      .pipe(map((res) => res?.data ?? []));
  }

  uploadDocument(
    request: UploadDocumentRequest
  ): Observable<BaseApiResponse<UploadDocumentModel>> {
    const url = `${this.baseUrl}/uploadDocument`;
    const formData = new FormData();

    formData.append('file', request.file, request.file.name);

    if (request.patientId) {
      formData.append('patientId', request.patientId);
    }

    if (request.woundId) {
      formData.append('woundId', request.woundId);
    }

    return this.apiService.postMultipart<UploadDocumentModel>(url, formData);
  }

  downloadDocument(documentId: string): Observable<Blob> {
    const url = `${this.baseUrl}/downloadDocument/${documentId}`;
    return this.apiService.getBlob(url);
  }

  getDocumentPreviewUrl(documentId: string): Observable<Blob> {
    const url = `${this.baseUrl}/getDocumentPreview/${documentId}`;
    return this.apiService.getBlob(url);
  }

  deleteDocument(documentId: string): Observable<BaseApiResponse<void>> {
    const url = `${this.baseUrl}/deleteDocument?Id=${documentId}`;
    return this.apiService.post<void>(url, { Id: documentId });
  }
}
